import React from "react";
import Modal from "react-bootstrap/Modal";
import Input from "../common/input";

const DependencyModal = ({
  show,
  data,
  errors,
  handleHide,
  handleChange,
  handleSubmit,
}) => {
  return (
    <Modal show={show} onHide={handleHide}>
      <Modal.Header closeButton className="bg-success text-white">
        <Modal.Title>Add Link</Modal.Title>
      </Modal.Header>
      <form>
        <Modal.Body>
          <div className="row">
            <div className="col">
              <p className="lead">Parent Child link from {data.firstCode}</p>
            </div>
          </div>
          <div className="form-row">
            <div className="col">
              <Input
                name="firstLabel"
                label="Parent Label"
                placeholder="Label"
                value={data.firstLabel}
                onChange={handleChange}
                error={errors.firstLabel}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col">
              <Input
                name="secondCode"
                label="Parameter"
                placeholder="Code"
                value={data.secondCode}
                onChange={handleChange}
                error={errors.secondCode}
              />
            </div>
            <div className="col">
              <Input
                name="secondLabel"
                label="Label"
                placeholder="Label"
                value={data.secondLabel}
                onChange={handleChange}
                error={errors.secondLabel}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={handleSubmit}>
            Save
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default DependencyModal;
